import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-blue-small-item.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var BannerBlueSmallItem = /** @class */ (function (_super) {
    tslib_1.__extends(BannerBlueSmallItem, _super);
    function BannerBlueSmallItem(element) {
        var _this = _super.call(this, element) || this;
        _this.w = 1200;
        _this.h = 480; // initial height of the image
        _this.ratio = _this.w / _this.h;
        return _this;
    }
    BannerBlueSmallItem.prototype.init = function () {
        this.imageHolder = this.element.querySelector('.hero-banner-item__image-holder');
        this.contentBackground = this.element.querySelector('.hero-banner-item__content-background');
        setTimeout(this.onResize.bind(this));
    };
    BannerBlueSmallItem.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
    };
    BannerBlueSmallItem.prototype.onResize = function () {
        var ww = window.innerWidth;
        var el = this.element;
        el.style.opacity = '1';
        if (ww > this.w) {
            var bannerHeight = ww / this.ratio;
            var colWidth = this.w / 12;
            var cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);
            // this.imageHolder.style.height = bannerHeight + 'px';
            this.contentBackground.style.width = cbWidth + 'px';
            this.contentBackground.style.height = bannerHeight + 'px';
        }
        else {
            this.contentBackground.style.removeProperty('height');
            if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = this.imageHolder.querySelector('img').offsetHeight + 'px';
            }
            else if (MediaQueryService.getMediaQuery() === 'medium') {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (5 * colWidth) + 'px';
            }
            else {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (4 * colWidth) + 'px';
            }
        }
    };
    return BannerBlueSmallItem;
}(Base));
export { BannerBlueSmallItem };



//////////////////
// WEBPACK FOOTER
// ./components/banner-blue-small-item/banner-blue-small-item.component.ts
// module id = 122
// module chunks = 0